var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:(_vm.contentId),expression:"contentId"}],staticClass:"text-expandable__label"},[_vm._v(_vm._s(_vm.label))]),_c('b-collapse',{attrs:{"id":_vm.contentId}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }